import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SessionService } from 'src/app/core/services/session.service';
import Constants from './../../../core/constants/constants';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { RestAPIsService } from 'src/app/core/services/rest-apis.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-edit-site',
  templateUrl: './edit-site.component.html',
  styleUrls: ['./edit-site.component.scss'],
})
export class EditSiteComponent implements OnInit {
  floors = Array(25);
  @Input() selectedSite: any;
  @Output() onClose = new EventEmitter<boolean>()
  siteForm: FormGroup;
  listOfPropertiesType = Constants.ListOfPropertiesType
  listOfAgeOfBuilding = Constants.ListOfAgeOfBuilding;
  successMessage = ''
  errorMessage = ''
  selectedSiteData:any = {}

  constructor(
    private modalService: NgbModal,
    private sessionService: SessionService,
    private restAPI: RestAPIsService,
    private spinner: NgxSpinnerService,
    private toaster: ToastrService
  ) {
    this.siteForm = new FormGroup({
      floorArea: new FormControl(null, Validators.required),
      floorCount: new FormControl(null, Validators.required),
      propertyType: new FormControl(null, Validators.required),
      decadeOfBuild: new FormControl(null, Validators.required),
      listedGrade: new FormControl(null, Validators.compose([
        Validators.required, Validators.pattern(/^[a-zA-Z0-9-]+$/), Validators.maxLength(10)])),
      premiseType: new FormControl(null, Validators.compose([
        Validators.required, Validators.pattern(/^[a-zA-Z0-9-]+$/), Validators.maxLength(20)])),
    })
  }

  ngOnInit(): void {
    this.selectedSiteData = this.sessionService.getItemFromSession(Constants.sessionConstants.SELECTED_SITE_DATA)
    if(this.selectedSite){
      this.siteForm.patchValue({
        floorArea: this.selectedSite.floorArea,
        floorCount: this.selectedSite.floorCount,
        propertyType: this.selectedSite.propertyType,
        decadeOfBuild: this.selectedSite.decadeOfBuild,
        listedGrade: this.selectedSite.listedGrade == 'N/A' ? null : this.selectedSite.listedGrade,
        premiseType: this.selectedSite.premiseType == 'N/A' ? null : this.selectedSite.premiseType,
      })
    }
  }

  close(reload = false): void {
    this.onClose.emit(reload);
    this.modalService.dismissAll();
  }

  updateSiteData(): void{
    if(this.siteForm.valid){
      this.successMessage = ''
      this.errorMessage = ''
      this.spinner.show();
      let payload: any = {};
 

      payload['email'] = this.sessionService.getItemFromSession(Constants.sessionConstants.COMPANY_SITE_DATA).contactEmail;
      payload['siteId'] = this.selectedSite?.siteId;
      payload['floorArea'] = Number((this.siteForm.get('floorArea')?.value));
      payload['floorCount'] = Number((this.siteForm.get('floorCount')?.value));
      payload['propertyType'] = this.siteForm.get('propertyType')?.value;
      payload['decadeOfBuild'] = this.siteForm.get('decadeOfBuild')?.value;
      payload['listedGrade'] = this.siteForm.get('listedGrade')?.value;
      payload['premiseType'] = this.siteForm.get('premiseType')?.value;
      this.restAPI.postAPI('carbon/v3/update-site-assumptions', payload, 'domestic').subscribe({
        next: (res) => {
          if (res?.status === 'Success') {
            const building = res.data.building
            this.selectedSite['floorArea'] = building?.floorArea?.value;
            this.selectedSite['floorCount'] = building?.floorCount?.value;
            this.selectedSite['propertyType'] = building?.propertyType?.value;
            this.selectedSite['listedGrade'] = building?.listedGrade?.value;
            this.selectedSite['premiseType'] = building?.premiseType?.value;
            this.toaster.success('Site information update successfully')
            
            // Store into memory
            if(this.selectedSiteData && this.selectedSite.siteId == this.selectedSiteData?.siteId){
              this.sessionService.setItemIntoSession(Constants.sessionConstants.SELECTED_SITE_DATA, this.selectedSite)
            }
            this.close(true)
          }
          else{
            this.errorMessage = res.data
          }
          this.spinner.hide();
        }, error: (err) => {
          console.log('ERRORS: ', err);
          // this.errorMessage = res.data
          this.spinner.hide();
        }
      })
    }
    else{
      this.siteForm.markAllAsTouched()
    }
  }
}
